const steps = [
  {
    id: 'planeacion',
    number: '01',
    title: 'Planeación',
    description:
      'Buscamos entender tu visión y necesidades para hacerlas nuestras. Trabajamos contigo para diseñar una solución pensada en ti y tus clientes.',
  },
  {
    id: 'diseno',
    number: '02',
    title: 'Diseño',
    description: 'Trabajamos contigo para diseñar una solución pensada en ti y tus usuarios.',
  },
  {
    id: 'desarrollo',
    number: '03',
    title: 'Desarrollo',
    description:
      'Seguimos los estándares de código mundiales cuidando la calidad de nuestros desarrollos.',
  },
];

/**
 * Los tres pasos del proceso de trabajo. Se muestra tanto en el home como en la
 * página de Nosotros.
 */
const WorkProcess = () => (
  <div className="workProcess">
    <h3>Te mostramos cómo trabajamos</h3>
    <p className="textBold">Nuestro proceso</p>

    <div className="workProcessSteps">
      {steps.map(({ id, number, title, description }) => (
        <div key={id}>
          <div className="workProcessCircle">
            <h5>{number}</h5>
          </div>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default WorkProcess;
